import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Field } from '@shared/ui/Input';

export const Wrap = styled.div`
  max-width: 1280px;
  margin: 0 auto;
`;

export const Back = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.5)};
  font-size: 13px;
  color: ${({ theme }) => theme.colors.text.secondary};
  text-decoration: none;
  margin-bottom: ${({ theme }) => theme.spacing(3)};
`;

export const Title = styled.h1`
  margin: 0 0 ${({ theme }) => theme.spacing(2)};
  font-size: 22px;
  font-weight: 600;
`;

export const Subtitle = styled.div`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 14px;
  margin-bottom: ${({ theme }) => theme.spacing(5)};
  max-width: 820px;
`;

export const Section = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(6)};
`;

export const SectionTitle = styled.h2`
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 ${({ theme }) => theme.spacing(3)};
`;

export const Card = styled.div`
  padding: ${({ theme }) => theme.spacing(5)};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.lg};
  background: ${({ theme }) => theme.colors.surface};
  max-width: 900px;
`;

export const Row = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(3)};
  flex-wrap: wrap;
  align-items: flex-end;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
`;

export const Th = styled.th`
  text-align: left;
  padding: ${({ theme }) => theme.spacing(2)};
  border-bottom: 2px solid ${({ theme }) => theme.colors.border};
  color: ${({ theme }) => theme.colors.text.secondary};
  font-weight: 600;
  white-space: nowrap;
`;

export const Td = styled.td`
  padding: ${({ theme }) => theme.spacing(2)};
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  vertical-align: middle;
`;

export const SmallBtn = styled.button`
  font-size: 12px;
  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(2)}`};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ theme }) => theme.colors.surface};
  color: ${({ theme }) => theme.colors.text.primary};
  cursor: pointer;
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Badge = styled.span<{ $tone: 'ok' | 'bad' | 'muted' | 'warn' }>`
  display: inline-block;
  padding: ${({ theme }) => `${theme.spacing(0.5)} ${theme.spacing(1.5)}`};
  border-radius: ${({ theme }) => theme.radius.sm};
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  color: #fff;
  background: ${({ theme, $tone }) =>
    $tone === 'ok'
      ? theme.colors.status.success
      : $tone === 'bad'
        ? theme.colors.status.danger
        : $tone === 'warn'
          ? theme.colors.status.warning
          : theme.colors.text.secondary};
`;

export const Notice = styled.div`
  padding: ${({ theme }) => theme.spacing(3)};
  border: 1px solid ${({ theme }) => theme.colors.status.warning};
  border-radius: ${({ theme }) => theme.radius.md};
  background: ${({ theme }) => theme.colors.surface};
  color: ${({ theme }) => theme.colors.text.primary};
  font-size: 13px;
  margin-bottom: ${({ theme }) => theme.spacing(4)};
  max-width: 900px;
`;

export const Mono = styled.code`
  font-size: 11px;
  color: ${({ theme }) => theme.colors.text.secondary};
  word-break: break-all;
`;

export const Msg = styled.div<{ $error?: boolean }>`
  margin-top: ${({ theme }) => theme.spacing(3)};
  font-size: 13px;
  color: ${({ theme, $error }) =>
    $error ? theme.colors.status.danger : theme.colors.text.secondary};
`;

// Extracted styled components replacing inline styles
export const NoAccessNotice = styled.div`
  opacity: 0.7;
  text-align: center;
  margin-top: 80px;
`;

export const WideField = styled(Field)<{ $minWidth?: number }>`
  min-width: ${({ $minWidth = 320 }) => `${$minWidth}px`};
`;

export const EmptyState = styled.div`
  opacity: 0.7;
`;

export const ErrorDetails = styled.div`
  font-size: 11px;
  margin-top: 2px;
  opacity: 0.8;
`;

export const ActionRow = styled(Row)`
  gap: 8px;
  margin-top: 8px;
`;

export const SubCard = styled(Card)`
  margin-top: 16px;
`;

export const SubSectionTitle = styled(SectionTitle)`
  font-size: 14px;
`;

export const InlineBtn = styled(SmallBtn)`
  margin-left: 8px;
`;

export const SubCardSubtitle = styled(Subtitle)<{ $marginBottom?: number }>`
  margin-bottom: ${({ $marginBottom = 12 }) => `${$marginBottom}px`};
`;

export const EvidenceBlock = styled.div`
  margin-bottom: 16px;
`;

export const EvidenceTitle = styled.strong`
  font-size: 13px;
`;

export const EvidenceContent = styled.div<{ $faded?: boolean }>`
  font-size: 13px;
  margin-top: 6px;
  opacity: ${({ $faded }) => ($faded ? 0.8 : 1)};
`;

export const EvidenceMonoRow = styled.div`
  margin-top: 4px;
`;

export const FormGridRow = styled(Row)`
  gap: 12px;
  align-items: flex-end;
  flex-wrap: wrap;
`;

export const ReasonCell = styled(Td)`
  font-size: 12px;
  opacity: 0.85;
`;

export const SubNotice = styled(Notice)`
  margin-top: 16px;
`;

export const NoticeBtnRow = styled.div`
  margin-top: 8px;
`;
